import { Sparkles } from "lucide-react";
import { motion } from "motion/react";
import {
  loadingStateContainerVariants,
  loadingStateTextVariants,
  loadingStateGradientAnimation,
  loadingStateIconAnimation,
  loadingStateTitleAnimation,
  loadingStateDotAnimation,
} from "@/features/shop/shared/animations/loadingStateAnimations";

export const ShopLoadingState = () => {
  return (
    <div className="flex flex-col items-center justify-center min-h-[calc(100vh-200px)] px-4">
      <motion.div
        className="relative w-full max-w-2xl rounded-2xl overflow-hidden"
        variants={loadingStateContainerVariants}
        initial="initial"
        animate="animate"
      >
        <div className="absolute inset-0 bg-gradient-to-br from-gray-100 via-gray-100/50 to-transparent dark:from-gray-800 dark:via-gray-800/50 dark:to-transparent" />

        <motion.div
          className="absolute inset-0 -z-10 opacity-30"
          initial={loadingStateGradientAnimation.initial}
          animate={loadingStateGradientAnimation.animate}
          transition={loadingStateGradientAnimation.transition}
          style={{
            background: "linear-gradient(135deg, rgba(236, 72, 153, 0.4) 0%, rgba(168, 85, 247, 0.4) 25%, rgba(59, 130, 246, 0.4) 50%, rgba(20, 184, 166, 0.4) 75%, rgba(236, 72, 153, 0.4) 100%)",
            backgroundSize: "200% 200%",
          }}
        />

        <div className="absolute inset-0 bg-white/40 dark:bg-gray-900/40 backdrop-blur-sm" />

        <div className="relative z-10 flex flex-col items-center justify-center gap-6 p-8 sm:p-12">
          <div className="relative">
            <motion.div
              className="relative"
              animate={loadingStateIconAnimation.animate}
              transition={loadingStateIconAnimation.transition}
            >
              <div className="rounded-2xl bg-white/60 dark:bg-gray-800/60 backdrop-blur-xl p-6 border border-gray-200/50 dark:border-gray-700/50 shadow-2xl">
                <Sparkles className="w-10 h-10 text-gray-700 dark:text-gray-300" strokeWidth={1.5} />
              </div>
            </motion.div>
          </div>

          <motion.div
            className="flex flex-col items-center gap-3 text-center"
            variants={loadingStateTextVariants}
          >
            <motion.h2
              className="text-xl sm:text-2xl font-bold text-gray-800 dark:text-gray-100"
              animate={loadingStateTitleAnimation.animate}
              transition={loadingStateTitleAnimation.transition}
            >
              Nous personnalisons votre boutique
            </motion.h2>
          </motion.div>

          <motion.div
            className="flex gap-2"
            variants={loadingStateTextVariants}
          >
            {[0, 1, 2].map((index) => {
              const dotAnim = loadingStateDotAnimation(index);
              return (
                <motion.div
                  key={index}
                  className="w-2 h-2 rounded-full border border-gray-200 dark:border-gray-400 bg-gray-200 dark:bg-gray-400"
                  animate={dotAnim.animate}
                  transition={dotAnim.transition}
                />
              );
            })}
          </motion.div>
        </div>
      </motion.div>
    </div>
  );
};
